import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "orientation-guard__panel" };
const _hoisted_2 = { class: "orientation-guard__title" };
const _hoisted_3 = { class: "orientation-guard__text" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrientationGuard',
    props: {
        visible: { type: Boolean },
        title: { default: '请横屏游玩' },
        message: { default: '移动端界面只维护横屏布局。若设备没有自动旋转，请手动横置后继续。' },
        actionLabel: { default: '尝试切换到横屏' }
    },
    emits: ["retry"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const emitRetry = () => {
            emit('retry');
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                _createVNode(_Transition, { name: "orientation-guard-fade" }, {
                    default: _withCtx(() => [
                        (__props.visible)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "orientation-guard",
                                role: "dialog",
                                "aria-modal": "true",
                                "aria-live": "polite",
                                onClick: _withModifiers(emitRetry, ["self"])
                            }, [
                                _createElementVNode("div", _hoisted_1, [
                                    _cache[0] || (_cache[0] = _createElementVNode("div", {
                                        class: "orientation-guard__icon",
                                        "aria-hidden": "true"
                                    }, [
                                        _createElementVNode("span")
                                    ], -1 /* CACHED */)),
                                    _createElementVNode("p", _hoisted_2, _toDisplayString(__props.title), 1 /* TEXT */),
                                    _createElementVNode("p", _hoisted_3, _toDisplayString(__props.message), 1 /* TEXT */),
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "orientation-guard__action",
                                        onClick: emitRetry
                                    }, _toDisplayString(__props.actionLabel), 1 /* TEXT */)
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                })
            ]));
        };
    }
});
